import { AppConstants } from '@ltvco/refresh-lib/ctx';
import { Box } from '@ltvco/refresh-lib/theme';
import { SideNavigationMenu } from '@ltvco/refresh-lib/v2';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

export function Sidenav({ onReport }: { onReport?: boolean }) {
  const {
    config: { sideMenuItems },
  } = useContext(AppConstants);
  const { pathname } = useLocation();
  const isDarkWebPage = pathname.includes('/dark-web');

  const newDesignFilteredSideMenuItems = sideMenuItems.filter(
    (item) => !(item.name === 'logout')
  );

  type RouteToHide = 'report' | 'dashboard';
  const hideItems: { name: string; routesToHide: RouteToHide[] }[] = [
    { name: 'myGarage', routesToHide: ['dashboard', 'report'] },
  ];
  if (!isDarkWebPage) {
    hideItems.push({ name: 'myAccount', routesToHide: ['report'] });
  }

  return (
    <Box
      sx={{
        display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
        '>.MuiList-root': {
          width: '310px',
          maxWidth: '310px',
        },
      }}
    >
      <SideNavigationMenu
        menuItems={newDesignFilteredSideMenuItems}
        matchingRoute={pathname}
        onReport={onReport}
        hideItems={hideItems}
      />
    </Box>
  );
}
